var _g, _rect, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgProfileWindowDarkBg(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 388,
    height: 436,
    viewBox: "0 0 388 436",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_45_113)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M401 406.5C401 439.913 374.361 467 341.5 467C308.639 467 282 439.913 282 406.5C282 373.087 308.639 346 341.5 346C374.361 346 401 373.087 401 406.5Z",
    fill: "#6C63FF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M84 406.5C84 439.913 57.3609 467 24.5 467C-8.36094 467 -35 439.913 -35 406.5C-35 373.087 -8.36094 346 24.5 346C57.3609 346 84 373.087 84 406.5Z",
    fill: "url(#paint0_linear_45_113)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-0.222223 220.838C-13.2222 179.838 -0.22222 188.838 -0.22222 188.838C4.37209 183.394 98.3048 209.517 70.7778 293.476C43.2508 377.434 155.502 370.108 161.278 371.476C258.764 369.324 315.563 359.079 340.778 436.338H-0.222223V220.838Z",
    fill: "url(#paint1_linear_45_113)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-19.2222 232.838C-32.2222 191.838 -19.2222 200.838 -19.2222 200.838C-14.6279 195.394 79.3048 221.517 51.7778 305.476C24.2508 389.434 136.502 382.108 142.278 383.476C239.764 381.324 296.563 371.079 321.778 448.338H-19.2222V232.838Z",
    fill: "url(#paint2_linear_45_113)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-41.2222 250.838C-54.2222 209.838 -41.2222 218.838 -41.2222 218.838C-36.6279 213.394 57.3048 239.517 29.7778 323.476C2.25082 407.434 114.502 400.108 120.278 401.476C217.764 399.324 274.563 389.079 299.778 466.338H-41.2222V250.838Z",
    fill: "url(#paint3_linear_45_113)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M54.801 134.386C22.2131 71.9623 -10.699 143.387 -14.699 88.3865C-18.6989 33.3865 -12.199 -23.1135 -12.199 -23.1135C113.479 -141.75 592.578 38.3528 370.301 10.3865C148.024 -17.5799 87.389 196.811 54.801 134.386Z",
    fill: "#6C63FF"
  }))), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 2,
    y: 2,
    width: 384,
    height: 432,
    stroke: "#6C63FF",
    strokeWidth: 4
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_45_113",
    x1: -49,
    y1: 400.5,
    x2: 70,
    y2: 400.5,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F7941E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#72C6EF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#00A651"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_45_113",
    x1: -6,
    y1: 312.169,
    x2: 340.778,
    y2: 312.169,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.380208,
    stopColor: "#6C63FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F1FAEE"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_45_113",
    x1: -25,
    y1: 324.169,
    x2: 321.778,
    y2: 324.169,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0885417,
    stopColor: "#6C63FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F1FAEE"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_45_113",
    x1: -47,
    y1: 342.169,
    x2: 299.778,
    y2: 342.169,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#6C63FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F1FAEE"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_45_113"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 388,
    height: 436,
    fill: "white"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgProfileWindowDarkBg);
export default __webpack_public_path__ + "static/media/profileWindowDarkBg.46ce03a34ec62d4dd2f2a72a19735507.svg";
export { ForwardRef as ReactComponent };